module.exports = __webpack_public_path__ + "static/dl-docs-icon-b4f3cd61bf5be37efc9d9ef318991e19.svg";